import styled from "styled-components";
import {
  FaBars,
  FaTimes,
} from "react-icons/fa";
import LOGO from "../assets/fl.png";
import { Link } from "react-router-dom";
import { smallScreen, tablet } from "../Utils/responsive";
import { useState } from "react";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/about" },
    { label: "Spare Parts", to: "/products" },
    // { label: "Services", to: "/services" },
    // { label: "Car Rental", to: "/car-rental" },
    { label: "Vehicle Sales", to: "/vehicle-sales" },
    // { label: "Training Centre", to: "/training-centre" },
     { label: "Car Tracking System", to: "/car-tracking-system" },
    { label: "Blog", to: "/blog" },
    { label: "Contact", to: "/contact" },
   
  ];

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <ContainerGeral>
      <ContainerMid>
        <FullWidthContainer>
          <MainBarContainer>
            <Link to="/">
              <Brand>
                <MainBarContainerLogo src={LOGO} alt="Felicie Auto Spare Parts LTD" />
                <BrandText>
                  <BrandName>Felicie Auto Spare Parts LTD</BrandName>
                  <BrandSub>Your car deserve the best and we deliver the best</BrandSub>
                </BrandText>
              </Brand>
            </Link>

            <Nav>
              {navItems.map((item) => (
                <Link key={item.to} to={item.to} style={{ textDecoration: "none" }}>
                  <PageLink>{item.label}</PageLink>
                </Link>
              ))}
            </Nav>

            <MobileMenuToggle onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </MobileMenuToggle>

          </MainBarContainer>
        </FullWidthContainer>

        <MobileNav isOpen={isMenuOpen}>
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              style={{ textDecoration: "none" }}
              onClick={() => setIsMenuOpen(false)}
            >
              <MobilePageLink>{item.label}</MobilePageLink>
            </Link>
          ))}
        </MobileNav>
      </ContainerMid>
    </ContainerGeral>
  );
};

export default NavBar;

/* ================= STYLES ================= */

const ContainerGeral = styled.div`
  font-size: 18px;
  font-weight: 700;
  position: sticky;
  top: 0;
  z-index: 20;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.08);
`;

const ContainerMid = styled.div`
  padding: 10px 0;
  width: 100%;
`;

const FullWidthContainer = styled.div`
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0 24px;
`;

const MainBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: nowrap;
  min-width: 0;
  width: 100%;
  padding: 8px 0;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const MainBarContainerLogo = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;
`;

const BrandText = styled.div`
  display: grid;
  gap: 3px;
  max-width: 200px;
  ${tablet({ display: "none" })}
`;

const BrandName = styled.span`
  color: #071116;
  font-size: 15px;
  line-height: 1.15;
  font-weight: 900;
  white-space: nowrap;
`;

const BrandSub = styled.span`
  color: #0b8ba0;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.4;
`;

const Nav = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
  ${smallScreen({ display: "none" })}
`;

const PageLink = styled.div`
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  margin: 4px 0;
  padding: 10px 10px;
  text-align: center;
  color: #18181d;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.02em;
  border-radius: 10px;
  transition: all 180ms ease;

  &:hover {
    background: rgba(227, 34, 43, 0.08);
    color: #e3222b;
  }

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 6px;
    transform: translateX(-50%);
    width: 0;
    height: 3px;
    background: #e3222b;
    transition: width 180ms ease;
  }

  &:hover::after {
    width: 50%;
  }

  ${tablet({
    margin: "2px 0",
    padding: "8px 8px",
    fontSize: "13px",
  })}
`;

const MobileMenuToggle = styled.div`
  display: none;
  cursor: pointer;
  font-size: 24px;
  color: #18181d;
  ${smallScreen({ display: "block" })}
`;

const MobileNav = styled.div`
  display: none;
  ${(props) => props.isOpen && smallScreen({ display: "flex" })}
  flex-direction: column;
  background: #fff;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  box-shadow: 0 10px 32px rgba(6, 24, 31, 0.08);
`;

const MobilePageLink = styled.div`
  padding: 16px 20px;
  color: #18181d;
  font-size: 16px;
  font-weight: 800;
  border-bottom: 1px solid #f0f0f0;
  &:hover {
    background: #f5f5f5;
  }
`;
